import { BaseHook } from './base.hook';

export class YourEmailHook extends BaseHook {
  static path = 'YourInformation.email';

  static execute(path, value, actions) {
    const emailValue = actions.getData('YourInformation.confirmEmail');
    if (emailValue !== null) {
      actions.setData('YourInformation.confirmEmail', '');
    }
  }
}
